export enum CHIP_VARIANT {
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue',
  PLATINUM = 'platinum',
  NAVY = 'navy',
  LIVID = 'livid',
  YELLOW = 'yellow',
  LIGHT = 'light',
  DARK = 'dark',
  PURPLE = 'purple',
  ORANGE = 'orange',
  PINK = 'pink',
  TEAL = 'teal',
  AQUA = 'aqua',
}
